// extracted by mini-css-extract-plugin
module.exports = {"sale-history":"sale-history-accordion_sale-history__2YYOW","sale-history-entries":"sale-history-accordion_sale-history-entries__Sr4XZ"};